import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import {
  AppEvent,
  AppEventType,
  EventQueueService,
  RoutesService,
  UserBeanService,
} from '@services';
import { AppState, setRequestedUrl } from '@store';

export const AuthReverseGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot
) => {
  const router: Router = inject(Router);
  const userBeanService = inject(UserBeanService);
  const routesService = inject(RoutesService);
  const store = inject(Store<AppState>);
  const eventQueueService = inject(EventQueueService);

  try {
    const userBean = await userBeanService.getUserBean();
    const { community, username } = route.queryParams;

    const hasMismatch =
      (community && community !== userBean.communityLoginName) ||
      (username && username !== userBean.username);

    if (hasMismatch) {
      const queryString = new URLSearchParams(route.queryParams).toString();
      const fullUrl = `${window.location.origin}/login${queryString ? '?' + queryString : ''}`;

      store.dispatch(setRequestedUrl({ payload: fullUrl }));
      eventQueueService.dispatch(
        new AppEvent(AppEventType.OPEN_DIFFERENT_SESSION_DIALOG)
      );

      if (router.navigated) {
        return false;
      } else {
        return router.createUrlTree(['/home']);
      }
    }

    return router.parseUrl(routesService.getPostAuthRedirect());
  } catch {
    return true;
  }
};
